<template>
  <div>
    <div class="table_theme-info">
      <b-table
        class="mb-0 pb-0"
        hover
        :items="skillValue"
        :fields="fields"
        fixed
      >
        <template v-slot:cell(value)="data">
          <b-form v-if="$can('update_all-skills')">
            <multiselect
              v-model="data.item.value"
              :options="skillScale"
              :allow-empty="false"
              :showLabels="false"
            />
          </b-form>
        </template>
        <template v-slot:cell(Actions)="data">
          <div class="d-flex">
            <b-button
              v-if="$can('delete-skills')"
              variant="secondary"
              class="button btn-icon ml-1"
              @click="deleteSkill(data.item.id)"
            >
              <span class="material-icons"> delete </span>
            </b-button>
          </div>
        </template>
      </b-table>
      <table class="table b-table b-table-fixed mb-0">
        <tbody>
          <tr>
            <td>
              <multiselect
                v-model="newSkill.skill"
                :options="skills"
                :allow-empty="false"
                :showLabels="false"
                label="name"
                track-by="id"
              />
            </td>
            <td>
              <multiselect
                v-model="newSkill.scale"
                :options="skillScale"
                :allow-empty="false"
                :showLabels="false"
              />
            </td>
            <td class="actions-column">
              <b-button
                variant="secondary"
                class="button btn-icon"
                @click="addSkill"
              >
                <span class="material-icons"> save </span>
              </b-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      fields: [
        {
          label: 'Name',
          key: 'name'
        },
        {
          label: 'Assessment',
          key: 'value'
        },
        {
          label: 'Actions',
          key: 'Actions',
          class: 'actions-column'
        }
      ],
      skills: [],
      skillScale: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      newSkill: {
        skill: null,
        scale: 1
      }
    }
  },

  mounted () {
    this.getSkills()
  },

  computed: {
    userSkills () {
      const selected = this.value.map(skill => skill.id)
      return this.skills.filter((s) => selected.includes(s.id))
    },

    skillValue: {
      get: function () {
        return this.value
      },
      set: function (newValue) {
        this.$emit('input', newValue)
      }
    }
  },

  methods: {
    addSkill () {
      if (!this.newSkill.skill) return
      this.skillValue.push({ id: this.newSkill.skill.id, value: this.newSkill.scale, name: this.newSkill.skill.name })
      this.$emit('input', this.skillValue)

      this.newSkill = {
        skill: null,
        scale: 1
      }
    },

    deleteSkill (skillId) {
      this.skillValue = this.skillValue.filter((s) => s.id !== skillId)
    },

    getSkills () {
      this.axios({
        method: 'get',
        url: '/api/skills',
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      })
        .then((response) => {
          this.skills = response.data
        })
        .catch((err) => {
          console.log(err)
          var errors = Object.values(err.response.data.errors)
          for (var i = 0; i < errors.length; i++) {
            this.$snotify.error(
              errors[i][0],
              'Error',
              this.$store.state.snotify
            )
          }
        })
    }
  }
}
</script>
